import { makeStyles } from '@mui/styles'
import { getPixelInREM } from 'common/material'

export const FLAG_WIDTH = 22

/**
 * The MUI class names are part of the selectors on purpose: these JSS rules are
 * injected before Material UI's own emotion styles, so without the extra
 * specificity resets like `MuiButtonBase-root { border: 0 }` would win.
 */
export const useLanguageSelectorStyles = makeStyles((theme) => ({
    trigger: {
        '&.MuiButtonBase-root': {
            display: 'inline-flex',
            alignItems: 'center',
            gap: getPixelInREM(8),
            height: getPixelInREM(32),
            padding: `0 ${getPixelInREM(8)}`,
            borderRadius: getPixelInREM(6),
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: theme.custom.colors.white,
            transition: 'background-color 150ms ease, border-color 150ms ease',
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.12)',
                borderColor: 'rgba(255, 255, 255, 0.6)'
            },
            '&:focus-visible': {
                outline: `2px solid ${theme.custom.colors.chartreuseGreen}`,
                outlineOffset: 2
            }
        }
    },
    triggerLabel: {
        fontSize: getPixelInREM(13),
        fontWeight: 600,
        letterSpacing: getPixelInREM(0.5),
        lineHeight: 1,
        color: theme.custom.colors.white
    },
    chevron: {
        fontSize: getPixelInREM(18),
        color: theme.custom.colors.white,
        opacity: 0.8,
        transition: 'transform 150ms ease',
        '&.open': {
            transform: 'rotate(180deg)'
        }
    },
    flag: {
        display: 'block',
        width: FLAG_WIDTH,
        height: 'auto',
        borderRadius: 2,
        border: '1px solid rgba(0, 0, 0, 0.15)',
        flexShrink: 0
    },
    menuPaper: {
        '&.MuiPaper-root': {
            marginTop: getPixelInREM(4),
            minWidth: getPixelInREM(180),
            borderRadius: getPixelInREM(6)
        }
    },
    menuItem: {
        '&.MuiMenuItem-root': {
            display: 'flex',
            alignItems: 'center',
            gap: getPixelInREM(10),
            fontSize: getPixelInREM(14),
            color: theme.custom.colors.oxfordBlue,
            '&.Mui-selected': {
                fontWeight: 600,
                backgroundColor: theme.custom.colors.blueGrayLight
            },
            '&.Mui-selected:hover': {
                backgroundColor: theme.custom.colors.blueGrayLight
            }
        }
    },
    menuItemName: {
        flex: 1
    },
    checkIcon: {
        fontSize: getPixelInREM(18),
        color: theme.custom.colors.oxfordBlue
    }
}))
